module.exports = __webpack_public_path__ + "5.0.2/img/jz_install.b225cdc9.jpg";